<template>
  <div class="login-bg">
    <div class="login-cont container">
      <div class="d-flex justify-content-center">
        <div class="col-12 px-0 d-flex flex-column">
          <!-- <img
            class="mx-auto mb-4"
            src="https://storage.googleapis.com/spacetech2/gkk365/gkk365.webp"
            alt="GKK365"
            @click="$router.push('/home')"
            style="height: 10rem"
          /> -->

          <div
            v-if="referralCode"
            class="referral-banner mx-auto mb-3"
            role="status"
          >
            <i class="fas fa-user-friends referral-banner__icon" aria-hidden="true" />
            <div class="referral-banner__text">
              <span class="referral-banner__label">{{ $t('auth.referral_applied') }}</span>
              <strong class="referral-banner__code">{{ referralCode }}</strong>
              <span v-if="referralStreamerName" class="referral-banner__streamer d-block small mt-1">
                {{ referralStreamerName }}
              </span>
            </div>
          </div>
          <div
            v-else-if="referralInvalid"
            class="referral-banner referral-banner--invalid mx-auto mb-3"
            role="alert"
          >
            <i class="fas fa-exclamation-circle referral-banner__icon" aria-hidden="true" />
            <span>{{ $t('auth.referral_invalid') }}</span>
          </div>

            <div class="card-body px-2 d-flex mx-0 col-12 mx-auto" style="background: rgba(255, 255, 255, 0.25);border-radius: 16px;box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);backdrop-filter: blur(10px);-webkit-backdrop-filter: blur(10px);">
              <div class="col-12">
                <div class="text-center mb-4">
                  <div class="error text-center py-2" v-if="error">
                    <span class="mx-auto">
                      {{$t('auth.fail_message')}}
                    </span>
                  </div>
                  </div>
                  <form role="form" @submit.prevent="loginWithPhone">
                  <small class="text-dark">{{ errors.name }}</small>
                  <div class="form-group mb-3">
                    <label style="color: black; font-weight: 550; letter-spacing: 0.5px;">{{$t('auth.username')}}</label>
                      <input
                        class="form-control pl-2 px-4"
                        style="background: linear-gradient(5deg,rgba(232, 121, 121, 1) 0%, rgba(250, 250, 250, 1) 100%) !important; color: black; box-shadow: none; border-radius: 8px; border: none; font-size: 1.2rem;"
                        type="text"
                        v-model="name"
                        @keyup.enter="focusOnPasswordInputBox"
                      />
                  </div>
                
                  <div class="form-group mb-3 pt-3">
                    <small class="text-dark">{{ errors.phone }}</small>
                    <label style="color: black; font-weight: 550; letter-spacing: 0.5px;">{{$t('setting.phone')}}</label>
                      <input
                        class="form-control pl-2 px-4"
                        style="background: linear-gradient(5deg,rgba(232, 121, 121, 1) 0%, rgba(250, 250, 250, 1) 100%) !important; color: black; box-shadow: none; border-radius: 8px; border: none; font-size: 1.2rem;"
                        type="text"
                        v-model="phone"
                        @keyup.enter="focusOnPasswordInputBox"
                      />
                  </div>
                  <small class="text-dark">{{ errors.password }}</small>
                  <div class="form-group pt-3">
                    <label style="color: black; font-weight: 550; letter-spacing: 0.5px;">{{$t('auth.password')}}</label>
                    <div class="input-group">
                      <input
                        class="form-control pl-2 px-4"
                        style="background: linear-gradient(5deg,rgba(232, 121, 121, 1) 0%, rgba(250, 250, 250, 1) 100%) !important; color: black; box-shadow: none; border-radius: 8px; border: none; font-size: 1.2rem;"
                        type="password"
                        ref="password"
                        v-model="password"
                        @keyup.enter="loginWithPhone"
                      />
                      <i
                        class="far fa-eye showable-password text-dark"
                        v-if="isShowPassword"
                        @click="showablePassword('password')"
                      ></i>
                      <i
                        v-if="!isShowPassword"
                        class="fas fa-eye-slash showable-password text-dark"
                        @click="showablePassword('password')"
                      ></i>
                    </div>
                  </div>
                  <small class="text-dark">{{ errors.confirm_password }}</small>
                  <div class="form-group pt-3">
                    <label style="color: black; font-weight: 550; letter-spacing: 0.5px;">{{$t('auth.confirm_password')}}</label>
                    <div class="input-group">
                      <input
                        class="form-control pl-2 px-4"
                        style="background: linear-gradient(5deg,rgba(232, 121, 121, 1) 0%, rgba(250, 250, 250, 1) 100%) !important; color: black; box-shadow: none; border-radius: 8px; border: none; font-size: 1.2rem;"
                        type="password"
                        ref="confirm_password"
                        v-model="confirm_password"
                        @keyup.enter="loginWithPhone"
                      />
                      <i
                        class="far fa-eye showable-password text-dark"
                        v-if="isShowConfirmPassword"
                        @click="showablePassword('confirm_password')"
                      ></i>
                      <i
                        v-if="!isShowConfirmPassword"
                        class="fas fa-eye-slash showable-password text-dark"
                        @click="showablePassword('confirm_password')"
                      ></i>
                    </div>
                  </div>

                  <div v-if="referralCode" class="form-group pt-2">
                    <label style="color: black; font-weight: 550; letter-spacing: 0.5px;">{{ $t('auth.referral_code') }}</label>
                    <input
                      class="form-control pl-2 px-4"
                      style="background: linear-gradient(5deg,rgba(232, 121, 121, 1) 0%, rgba(250, 250, 250, 1) 100%) !important; color: black; box-shadow: none; border-radius: 8px; border: none; font-size: 1.1rem; font-weight: 700; letter-spacing: 0.06em;"
                      type="text"
                      :value="referralCode"
                      readonly
                    />
                  </div>

                    <div class="text-center mt-4">
                      <button
                        type="submit"
                        class="btn my-4"
                        style="background: white; color: black; border-radius: 20px; width: 14rem; box-shadow: none;"
                        :disabled="isSignin"
                      >
                        <div v-if="!isSignin">
                          {{$t('auth.sign_up')}}
                        </div>

                        <Loading
                          color="#000000"
                          v-if="isSignin"
                          size="24"
                          class="px-4 py-0"
                        />
                      </button>
                    </div>
                    <div class="col-12 d-flex my-1">
                      <div class="col-5 p-0 my-auto" style="border-top: 1px solid white; height: 0;"></div> 
                      <div class="my-auto text-dark px-3">OR</div>
                      <div class="col-5 p-0 my-auto" style="border-top: 1px solid white; height: 0;"></div>
                    </div>
                    <div class="text-center mb-3">
                      <button
                        type="button"
                        class="btn my-4"
                        style="background: #10A931; color: white; border-radius: 20px; width: 10rem; box-shadow: none;"
                        @click="$router.push('/auth/login')"
                      >
                        <div>
                          {{$t('auth.login')}}
                        </div>
                      </button>
                    </div>
                  </form>
              </div>
            </div>
          <div class="row mt-3">
            <div class="col-4">
              <div
                class="modal fade"
                id="forgetPassword"
                tabindex="-1"
                role="dialog"
                aria-labelledby="modal-form"
                aria-hidden="true"
              >
                <div
                  class="modal-dialog modal- modal-dialog-centered"
                  role="document"
                >
                  <div class="modal-content">
                    <div class="modal-body p-5">
                      <b>
                        Please direct contact to customer service -
                        <span class="text-dark">09756477723</span>
                      </b>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast, Loading } from 'vant';
import { mapActions } from 'vuex';
import {
  getStoredReferralCode,
  parseReferralFromRoute,
  saveReferralCode,
} from '@/libs/referralCode';

export default {
  components: { Loading },
  data() {
    return {
      name: null,
      phone: null,
      password: null,
      confirm_password: null,
      referralCode: '',
      referralStreamerName: '',
      referralInvalid: false,
      error: false,
      errors: {},
      isSignin: false,
      isShowPassword: false,
      isShowConfirmPassword: false,
    };
  },
  watch: {
    $route: {
      handler() {
        this.syncReferralFromRoute();
      },
    },
  },
  methods: {
    ...mapActions(['fetchUser']),
    showablePassword(ref) {
      if(ref === 'password'){
        if (this.isShowPassword) {
          this.$refs[ref].type = 'password';
        } else {
          this.$refs[ref].type = 'text';
        }
        this.isShowPassword = !this.isShowPassword;
      } else {
        if (this.isShowConfirmPassword) {
          this.$refs[ref].type = 'password';
        } else {
          this.$refs[ref].type = 'text';
        }
        this.isShowConfirmPassword = !this.isShowConfirmPassword
      }
    },
    focusOnPasswordInputBox() {
      this.$refs.password.focus();
    },
    syncReferralFromRoute() {
      const fromRoute = parseReferralFromRoute(this.$route);
      if (fromRoute) {
        saveReferralCode(fromRoute);
        this.referralCode = fromRoute;
        this.validateReferralCode(fromRoute);
        return;
      }
      const stored = getStoredReferralCode();
      this.referralCode = stored;
      if (stored) {
        this.validateReferralCode(stored);
      }
    },
    async validateReferralCode(code) {
      this.referralInvalid = false;
      this.referralStreamerName = '';
      if (!code) {
        return;
      }
      try {
        const res = await this.axios.post('/streamers/validate-referral', {
          referral_code: code,
        });
        if (res.data && res.data.success) {
          this.referralStreamerName = res.data.data.streamer_name || '';
        }
      } catch (err) {
        this.referralInvalid = true;
        this.referralStreamerName = '';
      }
    },
    getReferralForRegister() {
      const fromRoute = parseReferralFromRoute(this.$route);
      if (fromRoute) {
        return saveReferralCode(fromRoute);
      }
      return getStoredReferralCode() || this.referralCode;
    },
    /**
     * login with phone
     */
    async loginWithPhone() {
      this.isSignin = true;
      this.errors = {};
      if (!this.name) {
        this.errors.name =
          this.$store.state.language === 'en'
            ? 'Required User Name'
            : 'User name လိုအပ်ပါသည်။';
        this.isSignin = false;
        return false;
      }
      if (!this.phone) {
        this.errors.phone =
          this.$store.state.language === 'en'
            ? 'Required Phone'
            : 'Phone လိုအပ်ပါသည်။';
        this.isSignin = false;
        return false;
      }
      if (!this.password) {
        this.errors.password =
          this.$store.state.language === 'en'
            ? 'Required Password'
            : 'Password လိုအပ်ပါသည်။';
        this.isSignin = false;
        return false;
      }
      if (!this.confirm_password) {
        this.errors.confirm_password =
          this.$store.state.language === 'en'
            ? 'Required Confirm Password'
            : 'Confirm Password လိုအပ်ပါသည်။';
        this.isSignin = false;
        return false;
      }
      if (this.confirm_password !== this.password) {
        this.errors.confirm_password =
          this.$store.state.language === 'en'
            ? 'Password not match!'
            : 'Password not match!';
        this.isSignin = false;
        return false;
      }

      const referralCode = this.getReferralForRegister();
      const payload = {
        user_name: this.name,
        phone: this.phone,
        password: this.password,
        confirmPassword: this.confirm_password,
        roles: 'normal',
      };
      if (referralCode) {
        payload.referralCode = referralCode;
      }

      try {
          const res = await this.axios.post('/auth/register', payload);
          localStorage.setItem('username', this.phone);
          localStorage.setItem('password', this.password);
          localStorage.setItem('token', res.data.token);

          
          await this.fetchUser();
          this.$router.push('/auth/login');

          Toast.success(
            this.$store.state.language === 'en'
              ? 'Success!'
              : 'Success!'
          );
      } catch (err) {
        this.error = true;
      }
      this.isSignin = false;
      return true;
    },
  },
  async mounted() {
    this.syncReferralFromRoute();
    const authUser = await this.fetchUser();
    if (authUser && this.$store.state.authUser.roles === 'normal')
      this.$router.push('/home');
    const userName = localStorage.getItem('username');
    const password = localStorage.getItem('password');
    if (userName && password) {
      this.name = userName;
      this.password = password;
    }
  },
};
</script>

<style scoped>
.login-bg {
  min-height: 100vh;
  width: 100%;
  overflow-y: auto;
  padding-bottom: 3rem;
  background-image: url("https://storage.googleapis.com/spacetech2/gkk365/Background-GKK365.webp");
  background-repeat: no-repeat;
  background-position: center;
  background-size: auto 100%;
  background-color: #8b0000;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.login-cont {
  padding-top: 3rem;
}

.referral-banner {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
  max-width: 420px;
  padding: 0.75rem 1rem;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}

.referral-banner--invalid {
  color: #9b1c1c;
  background: rgba(255, 240, 240, 0.95);
  border-color: rgba(197, 48, 48, 0.35);
  font-weight: 600;
}

.referral-banner__icon {
  color: #8b0000;
  font-size: 1.25rem;
}

.referral-banner__text {
  display: flex;
  flex-direction: column;
  text-align: left;
}

.referral-banner__label {
  color: #333;
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.referral-banner__code {
  color: #111;
  font-size: 1.1rem;
  font-weight: 800;
  letter-spacing: 0.06em;
}

.referral-banner__streamer {
  color: #555;
  font-weight: 600;
}

.showable-password {
  position: absolute;
  right: 15px;
  top: 15px;
  cursor: pointer;
  z-index: 1000;
}

.new-account-text {
  cursor: pointer;
}

.error {
  margin-bottom: 13px;
  display: flex;
  align-items: center;
  color: black;
  border: 1px solid black;
  border-radius: 8px;
  padding: 0px 15px;
  background: #ff000014;
}

.auth-card {
  background: #eeecec;
}
</style>
